import { createContext, useContext, useEffect, useLayoutEffect } from "react";

export const renderContext = createContext(typeof window === "undefined");

const useIsomorphicEffectHook =
	typeof window === "undefined" || global.FORCE_REACT_EFFECT ? useEffect : useLayoutEffect;

export default function useIsomorphicEffect(effect, deps) {
	const ssr = useContext(renderContext);
	const useHook = ssr ? useEffect : useIsomorphicEffectHook;

	return useHook(effect, deps);
}
